var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16663 5.66675C8.16663 5.20675 8.53996 4.83341 8.99996 4.83341C9.45996 4.83341 9.83329 5.20675 9.83329 5.66675C9.83329 6.12675 9.45996 6.50008 8.99996 6.50008C8.53996 6.50008 8.16663 6.12675 8.16663 5.66675ZM8.16663 8.16675C8.16663 7.70675 8.53996 7.33341 8.99996 7.33341C9.45996 7.33341 9.83329 7.70675 9.83329 8.16675V12.3334C9.83329 12.7934 9.45996 13.1667 8.99996 13.1667C8.53996 13.1667 8.16663 12.7934 8.16663 12.3334V8.16675ZM8.99996 15.6667C5.32413 15.6667 2.33329 12.6759 2.33329 9.00008C2.33329 5.32425 5.32413 2.33341 8.99996 2.33341C12.6758 2.33341 15.6666 5.32425 15.6666 9.00008C15.6666 12.6759 12.6758 15.6667 8.99996 15.6667ZM8.99996 0.666748C4.39746 0.666748 0.666626 4.39758 0.666626 9.00008C0.666626 13.6026 4.39746 17.3334 8.99996 17.3334C13.6016 17.3334 17.3333 13.6026 17.3333 9.00008C17.3333 4.39758 13.6016 0.666748 8.99996 0.666748Z",
    fill: "#e2a22d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0c61b0d2.svg";
export { ForwardRef as ReactComponent };